import type { QueryClient } from '@tanstack/react-query';

/**
 * Alle Ansichten, die Mitglieder zeigen, nach einer Änderung neu laden.
 *
 * Wichtig ist die Vollständigkeit: Die Mitgliederliste speist sich je nach
 * Filterlage aus `['members', …]` ODER aus der Volltextsuche `['search', …]`.
 * Wer nur `['members']` invalidiert, lässt frisch importierte Kontakte für
 * jeden, der gerade sucht oder filtert, unsichtbar — bis zum Seiten-Reload.
 *
 * Aktive Queries laden sofort neu, inaktive beim nächsten Mounten.
 */
export function invalidateMemberViews(qc: QueryClient): void {
  for (const key of [
    ['members'],
    ['search'],
    ['map'],
    ['matches'],
    ['contacts-import'],
  ] as const) {
    void qc.invalidateQueries({ queryKey: key });
  }
}
